export const MODAL_CAPTION = 'Import Synced Entities to License';
export const NOT_ENOUGH_CREDITS_MODAL_DESCRIPTION = `
    You do not have enough sync credits to transfer syncs to the new license.
    Please purchase more sync credits in order to complete this transfer.
`;
export const MODAL_DESCRIPTION = `
    Please select the license from which you would like to import synced entities.
    Syncing entities to new license will require the following amount of credits highlighted below.
`;

export const IMPORT_TASK_NAME = 'import-synced-entities';
export const IMPORT_TASK_PROGRESS_LABEL = 'Importing synced entities to new license';
export const IMPORT_TASK_SUCCESS_LABEL = 'Synced Entities imported to new license successfully';
export const IMPORT_TASK_FAILURE_LABEL = 'Error occurred while importing synced entities, no credits changed';
